/* global location */
/* eslint no-restricted-globals: ["off", "location"] */
import React, { Component } from 'react';
import { Search, Menu } from '@alife/next';
import SpaceImageUpload from "@alife/image-ad-upload"
import goldlog from "@ali/goldlog";
import { connect } from '@alife/tarot';
import $ from "jquery";
import Util from "../../util/common"
const { Item } = Menu;

class Header extends Component {

  constructor(opts) {
    super(opts);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
  }

  state = {
    keyword: "",
    overlayVisible: false
  }

  onSelect(keyword) {
    if (keyword) {
      this.setState({
        keyword: keyword[0],
        overlayVisible: false
      })
    }
  }

  onInputBlur() {
    this.setState({
      overlayVisible: false
    })
  }

  renderMenu() {
    const { list: dataSource } = this.props;
    const { width = 1190 } = this.props;
    let _w;
    if (width == 990) {
        _w = 296;
      } else if (width == 1190) {
        _w = 496;
      } else {
        _w = 704;
      }

    return (<Menu onSelect={this.onSelect.bind(this)} style={{ width: _w }} selectMode="single">
      {dataSource.map(item => (<Item key={item.label} className="clearfix">
        {item.label}
        <span className="red fr">约{item.count}个宝贝</span>
      </Item>))}
    </Menu>);
  }

  componentWillReceiveProps(nextProps) {
    //获取最新的建议数据
    const { list = [] } = this.props;
    const { list: list2 } = nextProps;
    if (list2.length > 0 && JSON.stringify(list) !== JSON.stringify(list2)) {
      this.setState({
        overlayVisible: true
      })
    } else if (list2.length == 0) {
      this.setState({
        overlayVisible: false
      })
    }
  }

  componentDidMount() {
    this.setState({
      keyword: pageConfig.keywords
    });
  }

  onChange(value) {
    const { dispatch } = this.props;
    if (value) {
      this.setState({
        keyword: value
      })
      dispatch("header/getList", {
        q: value
      });
    }
  }

  onSearch() {
    const obj = Util.getUrlParms();
    let spm = "";
    let spmAB = "";
    if (window.goldlog && window.goldlog.spm_ab) {
      spmAB = window.goldlog.spm_ab.join(".");
    }
    spm = (spmAB) ? `${spmAB}.dh_004.submit` : "a312h.2018_new_sem.dh_004.submit"
    Object.assign(obj, {
      keywords: "",
      sortType: "",
      descendOrder: "",
      province: "",
      city: "",
      priceStart: "",
      priceEnd: "",
      dis: "",
      provinceValue: "所在地区",
      p_rs: true,
      exp: window.pageConfig.exp,
      ptid : window.p4pObject && window.p4pObject.ptid || ""
    })
    obj.keywords = this.state.keyword;
    obj.spm = spm;
    delete obj.hpageId;
    // obj._version ="v3";
    //const origin = Util.getLocationOrigin();

    //const _url = origin + location.pathname;
    // const _url = 'https://p4psearch.1688.com/p4p114/p4psearch/offer.htm';
    const _url = 'https://p4psearch.1688.com/page.html?hpageId=old-sem-pc-list';
    const path = $.param(obj);
    console.log(path);

    window.__WPO.log(`keywords_${this.state.keyword}`, 1);
    goldlog.record('/szyx.pc_sem.keywords','CLK',`keyword=${this.state.keyword}`,'GET')
    window.location.href = `${_url}&${path}`;
  }

  render() {
    const { width = 1190 } = this.props;
    let _w;
    if (width == 990) {
      _w = 300;
    } else if (width == 1190) {
      _w = 530;
    } else {
      _w = 850;
    }
    // 图搜参数
    const wholeHeight = 50;
    const theme = 'p4pImage';
    const imgSearchUrlParam = {
      cosite: (window.p4pObject && window.p4pObject.cosite) || '',
      keywordid: (window.p4pObject && window.p4pObject.keywordid) || '',
      trackid: (window.p4pObject && window.p4pObject.trackid) || '',
      location: (window.p4pObject && window.p4pObject.location) || '',
      ptid: (window.p4pObject && window.p4pObject.ptid) || '',
      bd_vid: (window.p4pObject && window.p4pObject.bd_vid) || '',
    };
    const spm_ab = window.goldlog && window.goldlog.spm_ab ? window.goldlog.spm_ab.join(".") : "";
    const imgSearchSpm = (spm_ab) ? `${spm_ab}.dh_004.img_search` : "a312h.2018_new_sem.dh_004.img_search"
    return (
      <div
        className="header1688_new clearfix"
        onClick={this.onInputBlur.bind(this)}
        data-spm="dh_004"
      >
        <div className={`w_${width} header`}>
          <a
            className="sw-logo"
            href="https://re.1688.com"
            target="_blank"
            rel="noreferrer"
          />
          <div style={{ width: `${_w}px`, position: "relative" }}>
            <Search
              className="line_block ver-mid mr60"
              autoWidth
              combox={<div>{this.renderMenu()}</div>}
              overlayVisible={this.state.overlayVisible}
              style={{ width: _w }}
              hasIcon={false}
              searchText="搜索"
              onChange={this.onChange.bind(this)}
              onSearch={this.onSearch.bind(this)}
              value={this.state.keyword}
            />
            <div className="img-upload" id="img-upload">
              <SpaceImageUpload
                width={wholeHeight * 0.53 + "px"}
                height={wholeHeight * 0.47 + "px"}
                theme={theme}
                urlParam={imgSearchUrlParam}
                spm={imgSearchSpm}
              />
            </div>
          </div>
          <div className="qrcode" />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
    ...state.header
  });
export default connect(mapStateToProps)(Header)
